import React, { ChangeEvent, ReactElement, useState } from 'react';
import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { filterSelectedClients, getClientOptionString, isClientSelected } from './AutocompleteHelper';
import { ClientDto } from '../../../api/ClientApi';

type ClientAutocompleteProps = {
    isRequired?: boolean;
    title?: string;
    clients: ClientDto[];
    selectedClientId?: number;
    selectClient(clientId?: number): void;
};

export default function ClientAutocomplete(props: ClientAutocompleteProps): ReactElement {
    const { isRequired, title, clients, selectedClientId, selectClient } = props;

    const [clientFilter, setClientFilter] = useState<string>('');

    const handleClientIdSelect = (clientId?: number) => {
        selectClient(clientId);
    };

    const handleClientSelect = (event: ChangeEvent<unknown>, value: string | null): void => {
        if (value !== null) {
            const searchedClient = clients?.find((a) => {
                return isClientSelected(a, value);
            });

            if (!!searchedClient && !!searchedClient.id && searchedClient?.id >= 0) {
                handleClientIdSelect(searchedClient.id);
            }
        } else {
            handleClientIdSelect(undefined);
        }
    };

    const handleClientFilterChange = (event: ChangeEvent<{ value: unknown }>): void => {
        const searchToken: string = (event.target.value as string) ?? '';

        setClientFilter(searchToken);
    };

    return (
        <Autocomplete
            freeSolo
            options={clients.map((option) => getClientOptionString(option))}
            filterOptions={(x) => {
                return filterSelectedClients(x, clientFilter);
            }}
            value={selectedClientId ? getClientOptionString(clients.find((a) => a.id === selectedClientId)) : null}
            onChange={handleClientSelect}
            renderInput={(params) => (
                <TextField
                    {...params}
                    required={isRequired}
                    error={isRequired && (!selectedClientId || selectedClientId === 0)}
                    fullWidth
                    label={title ?? 'Dobavljač'}
                    variant="outlined"
                    style={{ backgroundColor: '#f7f7f7', borderRadius: 5 }}
                    onChange={handleClientFilterChange}
                />
            )}
        />
    );
}
